import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UiGroupControl } from '@shared/ui/controls/ui-group-control.model';
import { DateControl } from '@shared/ui/controls/date-control.model';
import { ViewControl } from '@shared/ui/controls/view-control.model';
import { BaseControl } from '@shared/ui/controls/base-control.model';
import { UrlHelperService } from '../services/url-helper.service';
import { ToggleControl } from '../../shared/ui/controls/toggle-control.model';
import { SelectControl } from '../../shared/ui/controls/select-control.model';
import { AuthenticationService } from './authentication.serivce';
import { OrganizationSelect } from '../../shared/ui/select-controls/organizations-select.model';
import { ViewRowControl } from '../../shared/ui/controls/view-row-control.model';

@Injectable()
export class SearchService<TRowEntity> {

  //private apiUrl: string = this.urlHelper.getApiUrl();
  private corsHeaders: HttpHeaders;

  constructor(private http: HttpClient, private urlHelper: UrlHelperService, private auth: AuthenticationService) {
    this.corsHeaders = new HttpHeaders({
      'Content-Type': 'application/json'
    });
  }

  performSearch(apiController: string, views: ViewControl[]): Observable<Array<TRowEntity>> {

    var postData = this.buildPostData(views);
    var url = this.buildUrl(apiController);

    return this.http.post<Array<TRowEntity>>(url, postData);
  }

  buildUrl(apiController: string): string {
    var apiUrl = this.urlHelper.getApiUrl();
    if (!apiUrl.endsWith(apiController)) {
      apiUrl += apiController;
    }

    return apiUrl;
  }

  buildPostData(views: ViewControl[]): any {

    var session = this.auth.getSession();

    //WE MUST PASS THROUGH THE CURRENT ORGANIZATION ID!!

    var postData: { [k: string]: any } = {};
    postData['organizationId'] = session?.organizationId;

    var controls = this.flatten(views);
    for (var i = 0; i < controls.length; i++) {
      var control = controls[i];
      var value = Reflect.get(control, "value");

      var tempValue: any;
      if (control instanceof DateControl || control instanceof ToggleControl) {
        tempValue = value;
      } else if (control.constructor.name.endsWith("Select")) {
        var select = control as SelectControl;
        if (select.allowMultiple === false) {
          if (select.singleValue && typeof select.singleValue === 'object') {
            tempValue = select.singleValue[select.valueMember];
          } else {
            tempValue = null;
          }
        } else {
          if (select.value) {
            var values = select.value.map(v => v[select.valueMember]);
            tempValue = values.join("\n");
          } else {
            tempValue = null;
          }
        }
      } else {
        tempValue = String(value);
      }

      if (tempValue !== undefined && tempValue !== null && tempValue !== "" && tempValue !== "null") {
        var postAsArray = Reflect.get(control, "postAsArray");
        var postArray = Boolean(postAsArray);
        if (postArray === true) {
          if (tempValue != null && tempValue.length > 0) {
            if (tempValue.includes("\n")) {
              postData[control.id] = tempValue.split("\n");
            } else {
              postData[control.id] = [tempValue];
            }
          } else {
            postData[control.id] = [];
          }
        } else {
          postData[control.id] = tempValue;
        }
      }
    }

    

    return postData;
  }

  private flatten(views: ViewControl[]): BaseControl[] {
    var arrs: BaseControl[][] = views.map(v => {

      const view: ViewControl = { ...v };
      var ctrls = view.controls;

      var rows = ctrls.map(g => (g as UiGroupControl).rows);
      var arrRows = rows.reduce((accumulator, value) => accumulator.concat(value), []);

      var controls = arrRows.map(r => r.controls);
      var arrControls = controls.reduce((accumulator, value) => accumulator.concat(value), []);

      return arrControls;
    });

    return arrs.reduce((accumulator, value) => accumulator.concat(value), []);
  }
}
